import script from "./HistoryCont.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryCont.vue?vue&type=script&setup=true&lang=js"

import "./HistoryCont.vue?vue&type=style&index=0&id=7ddcbdc4&lang=scss"
import "./HistoryCont.vue?vue&type=style&index=1&id=7ddcbdc4&lang=scss"

const __exports__ = script;

export default __exports__